import { typeActions } from 'state/util'

const { actions, types } = typeActions('sideBar', {
  fetchWalletMovements: data => ({ payload: data }),
  setWalletMovements: data => ({ payload: data }),
  setLoading: value => ({ meta: { loading: value } }),
  setSideBarProps: (key, collapsed = false) => ({
    meta: {
      current: key,
      collapsed,
    },
  }),
})

export {
  actions,
  types,
}
